// ID関連の共通サービス

/**
 * テーブルの行番号を設定する。
 * @param data
 * @param name
 * @param offset
 * @returns
 */
export const mapIds = (data: any[], name: string, offset: number = 0) => {
  data.map((v: any, i: number) => (v[name] = i + 1 + offset));
  return data;
};

/**
 * ロケーションコードを取得する。
 * @param value
 * @param defaultValue
 * @returns
 */
export const locationCd = (value: string, defaultValue: string): string => {
  const cd = value.toUpperCase().replace(/-/g, "");
  const arr = cd.match(/.{1,2}/g);
  if (!arr) return "";
  const [zone, ...other] = arr;
  if (!zone) return defaultValue;
  if (zone.match(/^[A-Z0-9]+$/) === null) return defaultValue;
  for (const v of other) {
    if (v.match(/^[0-9]+$/) === null) return defaultValue;
  }
  return cd.match(/.{1,2}/g)?.join("-") ?? defaultValue;
};
